import { gql } from '@apollo/client'

export const SABRE_BRAND_FRAGMENT = gql`
  fragment Brand on Brand {
    id
    name
    category {
      id
      name
    }
    parent {
      id
      name
    }
  }
`
